var map = {
	"./words_4.json": [
		217,
		217
	],
	"./words_5.json": [
		190,
		190
	],
	"./words_6.json": [
		972,
		972
	],
	"./words_7.json": [
		523,
		523
	],
	"./words_8.json": [
		45,
		45
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 145;
module.exports = webpackAsyncContext;